const API_BASE_URL = 'http://localhost:4000/api';

// Helper function to make API calls
const apiCall = async (endpoint, method = 'GET', data = null, token = null) => {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json'
    }
  };

  // Add authorization token if provided
  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }

  // Add body for POST/PUT requests
  if (data && (method === 'POST' || method === 'PUT')) {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, options);

    // Read body as text first so we can safely handle empty or non-JSON responses
    const text = await response.text();
    let result = {};
    if (text) {
      try {
        result = JSON.parse(text);
      } catch (parseErr) {
        // not JSON — keep raw text available
        result = { _raw: text };
      }
    }

    if (!response.ok) {
      // try to surface a meaningful message
      const msg = (result && (result.message || result.error)) || result._raw || text || 'API request failed';
      throw new Error(`HTTP ${response.status} ${response.statusText}: ${msg}`);
    }

    return result;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

// Authentication APIs
export const authAPI = {
  // Partner Signup
  signupPartner: async (businessName, ownerName, email, mobile, password) => {
    return await apiCall('/auth/signup/partner', 'POST', {
      businessName,
      ownerName,
      email,
      mobile,
      password
    });
  },

  // Customer Signup
  signupCustomer: async (fullName, email, mobile, password) => {
    return await apiCall('/auth/signup/customer', 'POST', {
      fullName,
      email,
      mobile,
      password
    });
  },

  // Login (Universal)
  login: async (email, password) => {
    return await apiCall('/auth/login', 'POST', {
      email,
      password
    });
  },

  // Get User Profile
  getProfile: async (token) => {
    return await apiCall('/auth/profile', 'GET', null, token);
  },

  // Update Customer Profile
  updateCustomer: async (data, token) => {
    return await apiCall('/auth/update/customer', 'PUT', data, token);
  },

  // Update Partner Profile
  updatePartner: async (data, token) => {
    return await apiCall('/auth/update/partner', 'PUT', data, token);
  }
};

// Health Check
export const healthCheck = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/health`);
    return await response.json();
  } catch (error) {
    console.error('Health check failed:', error);
    return { status: 'Server is down' };
  }
};

// Contact API
export const contactAPI = {
  sendMessage: async (data) => {
    return await apiCall('/websitecontact', 'POST', data);
  }
};
export default authAPI;
